import React, { FunctionComponent } from 'react';
import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons';
import { BrassIcon, BrassIconProps } from '.';

const BrassIconAlert: FunctionComponent<BrassIconProps> = (
  props: BrassIconProps,
) => <BrassIcon {...props} icon={faExclamationCircle} />;

export { BrassIconAlert };
